/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-03 10:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button, ButtonGroup } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  onSave: () => void,
  isDisableSave: boolean,
  isLoading: boolean
};

type ComposedProps = WithI18nProps & Props;

class ActionGroup extends Component<ComposedProps> {
  render() {
    const { i18n, isDisableSave, isLoading, onSave } = this.props;
    return (
      <ButtonGroup>
        <Button onClick={this.handleCancel} disabled={isLoading}>
          {i18n.translate('AdminHTML.Common.Action.cancel')}
        </Button>
        <Button primary onClick={onSave} disabled={isDisableSave} loading={isLoading}>
          {i18n.translate('AdminHTML.Common.Action.save')}
        </Button>{' '}
      </ButtonGroup>
    );
  }

  handleCancel = () => {
    history.push(routes.manualRecommendation.list());
  };
}

export default withI18n()(ActionGroup);
